import TagItem from "./TagItem";
import { Tag } from "../../types/Tag";

import React from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";

interface TagsListProps {
    tags: Tag[];
}

const TagsList: React.FC<TagsListProps> = ({ tags }) => {
    if (tags.length === 0) {
        return (
            <Typography variant="h5" display={"flex"} justifyContent={"center"} p={10}>
                No results found.
            </Typography>
        );
    }

    return (
        <Grid container spacing={2}>
            {tags.map((tag: Tag) => (
                <TagItem tag={tag} key={tag.id} />
            ))}
        </Grid>
    );
};

export default TagsList;
